import React from 'react';
import { stats } from '../data/content';
export function Stats() {
  return <section className="w-full border-y border-navy/10 bg-white px-4 py-8" aria-label="Cifras" data-id="element-228" data-mp="2wxqf6edmwmjh">
      <div className="mx-auto grid w-full max-w-3xl grid-cols-2 gap-y-6 sm:grid-cols-4" data-id="element-229" data-mp="2ixxogj23y6bi">
        {stats.map(s => <div key={s.label} className="flex flex-col items-center px-2 text-center" data-id="element-230" data-mp="2nwinwg9jclyw">
            <span className="font-display text-2xl font-bold text-navy sm:text-3xl" data-id="element-231" data-mp="298e3n7uu42e0">{s.value}</span>
            <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-navy/50 sm:text-xs" data-id="element-232" data-mp="2dym7b8xtwyte">
              {s.label}
            </span>
          </div>)}
      </div>
    </section>;
}